<div id="ficha-cartera" (mouseenter)="setHovered(true)" (mouseleave)="setHovered(false)"
  class="card-moneda bg-white border-radius-20 border-1 primary-300 shadow-4 p-3 h-100 d-flex flex-column justify-content-between">
  <div class="image-container mb-3 d-flex justify-content-end">
    <img src="{{criptoCardData.imgSrc}}" alt="{{criptoCardData.title}}" title="{{criptoCardData.title}}">
  </div>
  <div class="d-flex flex-column justify-content-end h-100">
    <h3 class="{{isHovered ? 'primary-500' : 'primary-900'}} mb-1">{{criptoCardData.title}}</h3>
    <p class="p2-medium {{isHovered ? 'primary-500' : 'primary-800'}} mb-1">{{criptoCardData.subtitle}}</p>
  </div>
</div>